import { LinearProgress } from '@material-ui/core'

export default ({ paymentRequest, amount, loading, prepaymentSignup }) => {
  const [disabled, setDisabled] = useState(true)
  const [signupComplete, setSignupComplete] = useState(false)
  const dispatch = useDispatch()
  const signupSuccess = useSelector((state) => state.local.signupSuccess)
  const signupValidation = useSelector((state) => state.local.signupValidation)

  useEffect(() => {
    setDisabled(false)
    if (signupSuccess) {
      setSignupComplete(true)
      dispatch({
        type: 'local/upsert',
        payload: { signupSuccess: null },
      })
    }
  }, [signupSuccess])

  useEffect(() => {
    if (signupValidation) {
      setDisabled(false)
      dispatch({
        type: 'local/upsert',
        payload: { signupValidation: null },
      })
    }
  }, [signupValidation])

  const signup = () => {
    setDisabled(true)
    dispatch({
      type: 'local/upsert',
      payload: { doSignup: true },
    })
  }

  const pay = () => {
    setDisabled(true)
    paymentRequest.show()
  }

  if (!!paymentRequest) paymentRequest.on('cancel', () => setDisabled(false))

  const prePay = prepaymentSignup && !signupComplete

  return loading ? (
    <div>
      <Typography variant="body2" gutterBottom>
        Loading...
      </Typography>
      <LinearProgress />
    </div>
  ) : (
    <Grid container spacing={3} style={{ marginTop: 15 }}>
      <Grid item xs={12} md={6}>
        <Button
          variant="contained"
          color={prePay ? 'default' : 'secondary'}
          fullWidth
          disabled={disabled}
          onClick={prePay ? signup : pay}
        >
          {prePay ? 'Confirm details' : `Donate £${amount / 100} now`}
        </Button>
      </Grid>
    </Grid>
  )
}
